import { AuthenticatedTemplate } from "@azure/msal-react";
import "./index.scss";
import Hook from "./usePricing";
import helper from "./pricingHelper";
import Loader from "@moneris-portal/loader";
import { SecondaryButton } from "@moneris-portal/button";
import PricingOption from "../../../components/QBO_Accounting/PricingOption";
import infoIcon from "../../../assets/info_icon.svg";

function QBO_Pricing(params) {
  const {
    BLOCK,
    translate,
    isReady,
    isNavigating,
    selectedPlan,
    trialEligible,
    isSubmitting,
    error,
    isChangePlanMode,
    hasChanged,
    changePlanBannerText,
    handleSelectPlan,
    handleBack,
    handleSubmit,
  } = Hook.usePricing(params);

  if (!isReady || isNavigating) {
    return <Loader />;
  }

  const showTrialBanner = !isChangePlanMode && trialEligible;
  const showChangePlanBanner = isChangePlanMode && changePlanBannerText;
  const buttonDisabled = isChangePlanMode
    ? !hasChanged || isSubmitting
    : !selectedPlan || isSubmitting;
  const buttonText = isChangePlanMode
    ? translate("pricing-update-plan")
    : translate("pricing-start-trial");

  return (
    <AuthenticatedTemplate>
      <div className={BLOCK.current}>
        <div className={`${BLOCK.current}__container`}>
          <div className={`${BLOCK.current}__header`}>
            <h1>{translate("pricing-title")}</h1>
          </div>

          {showTrialBanner && (
            <div className={`${BLOCK.current}__trial-banner`}>
              <img
                className={`${BLOCK.current}__trial-banner-icon`}
                src={infoIcon}
                alt=""
                aria-hidden="true"
              />
              <span
                dangerouslySetInnerHTML={{
                  __html: translate("pricing-trial-badge"),
                }}
              />
            </div>
          )}

          {showChangePlanBanner && (
            <div className={`${BLOCK.current}__change-plan-banner`}>
              <img
                className={`${BLOCK.current}__change-plan-banner-icon`}
                src={infoIcon}
                alt=""
                aria-hidden="true"
              />
              <span>{changePlanBannerText}</span>
            </div>
          )}

          {error && (
            <div className={`${BLOCK.current}__error`}>{error}</div>
          )}

          <PricingOption
            name="plan"
            type="monthly"
            lang={params.lang}
            isSelected={selectedPlan === helper.BILLING_FREQUENCY.MONTHLY}
            onChange={() => handleSelectPlan(helper.BILLING_FREQUENCY.MONTHLY)}
          />

          <PricingOption
            name="plan"
            type="annual"
            lang={params.lang}
            isSelected={selectedPlan === helper.BILLING_FREQUENCY.YEARLY}
            onChange={() => handleSelectPlan(helper.BILLING_FREQUENCY.YEARLY)}
          />

          <p className={`${BLOCK.current}__disclaimer`}
            dangerouslySetInnerHTML={{
              __html: translate("pricing-disclaimer-1"),
            }}
          />

          {isChangePlanMode ? (
            <div className={`${BLOCK.current}__button-row`}>
              <div className={`${BLOCK.current}__back-btn`}>
                <SecondaryButton
                  clickHandler={handleBack}
                  title={translate("pricing-go-back")}
                />
              </div>
              <button
                className={`${BLOCK.current}__submit-btn`}
                onClick={handleSubmit}
                disabled={buttonDisabled}
                type="button"
              >
                {isSubmitting ? (
                  <div className={`${BLOCK.current}__loader-container loader_panel`}>
                    <div className="spinner" />
                  </div>
                ) : (
                  buttonText
                )}
              </button>
            </div>
          ) : (
            <button
              className={`${BLOCK.current}__submit-btn`}
              onClick={handleSubmit}
              disabled={buttonDisabled}
              type="button"
            >
              {isSubmitting ? (
                <div className={`${BLOCK.current}__loader-container loader_panel`}>
                  <div className="spinner" />
                </div>
              ) : (
                buttonText
              )}
            </button>
          )}
        </div>
      </div>
    </AuthenticatedTemplate>
  );
}

export default QBO_Pricing;

